module.exports = __webpack_public_path__ + "static/media/chevron_solid_green.87258532.svg";